import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=8091a20c&scoped=true&"
import script from "./UserFilter.vue?vue&type=script&lang=ts&"
export * from "./UserFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8091a20c",
  null
  
)

/* custom blocks */
import block0 from "./UserFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports